import blogPosts from "../data/blog.json";
import {BlogCard} from "../components/ui/BlogCard";
import Layout from "../components/ui/layout";

export const Blog = () => {
    return (
        <Layout>
            <section className="pb-12 max-w-6xl m-auto overflow-hidden 2xl:overflow-visible">
                <div className="max-w-full mx-auto">
                    {blogPosts.map((blog, index) => (
                        <BlogCard key={index} blogPost={blog} />
                    ))}
                </div>
            </section>
        </Layout>
    )
}
